import { Text, useStyleConfig } from '@tectonic/elemason-components';
import clsx from 'clsx';
import { useAccessorValue } from '../../hooks/useAccessorValue';

import type {
  ElemasonProductIngredientsWidget,
  ProductIngredients,
} from '@tectonic/types';
import type { FC } from 'react';

interface ElemasonProductIngredientsWidgetProps {
  widget: ElemasonProductIngredientsWidget;
}

const ProductIngredientsWidget: FC<ElemasonProductIngredientsWidgetProps> = ({
  widget: { config, data },
}) => {
  const { className: contClassName, style: contStyle } = useStyleConfig(
    config?.container ?? {}
  );
  const productIngredientsList: ProductIngredients[] =
    useAccessorValue(data?.ingredients ?? {}) || [];

  if (productIngredientsList.length === 0) {
    return null;
  }

  return (
    <div className={clsx('flex flex-col', contClassName)} style={contStyle}>
      <Text
        config={config?.text}
        data={productIngredientsList
          .map((productIngredient) => productIngredient.name)
          .join(', ')}
      />
    </div>
  );
};

export { ProductIngredientsWidget };
